const API_URL = process.env.REACT_APP_API_URL;

export const fetchSettings = async () => {
  try {
    const response = await fetch(`${API_URL}/applicationsettings`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
      },
    });
    
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching settings`, error);
    throw error;
  }
};

export const saveSettings = async (settings) => {
  try {
    const response = await fetch(`${API_URL}/applicationsettings/save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
      },
      body: JSON.stringify(settings),
    });
    
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error saving settings`, error);
    throw error;
  }
};

